import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { ActivatePromotionResult } from '../types';

import { useLegacyActivatePromotion } from './use-legacy-activate-promotion';
import { useLoyaltyServiceActivatePromotion } from './use-loyalty-service-activate-promotion';

export function useActivatePromotion(): ActivatePromotionResult {
  const serviceEnabled = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_SERVICE_PROMOTIONS);

  // Both sources stay mounted for a stable hook order; only the callback for the
  // active source is returned, so legacy flow is untouched when the flag is off.
  const legacy = useLegacyActivatePromotion();
  const service = useLoyaltyServiceActivatePromotion();

  return serviceEnabled ? service : legacy;
}
